import { useQuery } from '@apollo/client';

import useCompanyContext from 'common/hooks/useCompanyContext';

import { DeactivateVirtualCardConfirmDocument } from './deactivateVirtualCard.gql';

const useDeactivateVirtualCardConfirmQuery = () => {
  const { companyProfileId } = useCompanyContext();

  return useQuery(DeactivateVirtualCardConfirmDocument, {
    // No need to store quotas in the cache. Doing so might result in invalid
    // values being displayed to the users
    fetchPolicy: 'no-cache',
    skip: !companyProfileId,
    variables: { companyProfileId: companyProfileId || '' },
  });
};

export default useDeactivateVirtualCardConfirmQuery;
